import {getLocalData} from "../services/StorageServices"
import {useState} from "react"
import {useSelector} from 'react-redux'

const _checkRoles = (role) => {
    const roles = getLocalData('roles')
    const rolesState = useSelector(state => state.rolesReducer.roles)
    const [rolesApi] = useState(!!rolesState && rolesState.length > 0 ? rolesState : roles)

    if (!!rolesApi && rolesApi.length > 0) {
        const hasRole = rolesApi.filter(item => item.roleCode.toLowerCase() === role.toLowerCase())

        if (hasRole.length > 0) {
            return true
        }
    }

    return false
}

export default _checkRoles